(() => {
  const boot = (root) => {
    if (!root || root.dataset.lx13Booted) return;
    root.dataset.lx13Booted = '1';
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const money = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 });

    /* hero waits for the intro to lift */
    const gate = document.querySelector('[data-lxi]');
    const introActive = gate && !gate.classList.contains('is-gone') && !document.documentElement.classList.contains('lxi-skip');
    // a timeout rather than a frame, so the hero still settles if the tab was in the background
    const ready = () => setTimeout(() => root.classList.add('is-ready'), 30);
    // wait for the gift box (or the older clover intro) to open before the hero settles
    if (document.documentElement.classList.contains('lxb-on') || introActive) document.addEventListener('lucino:intro-done', ready, { once: true });
    else ready();

    /* reveal on scroll */
    const reveals = $$('.lx13-reveal');
    if (reduce || !('IntersectionObserver' in window)) reveals.forEach((el) => el.classList.add('is-visible'));
    else {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach((el) => io.observe(el));
    }

    /* gallery */
    const slides = $$('.lx13-gallery__slide');
    const thumbs = $$('[data-lx13-thumb]');
    const counter = $('[data-lx13-current]');
    let index = 0;
    const show = (n) => {
      if (!slides.length) return;
      index = (n + slides.length) % slides.length;
      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
        const img = s.querySelector('img');
        if (i === index && img) img.loading = 'eager';
      });
      thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.setAttribute('aria-selected', String(i === index)); });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $('[data-lx13-prev]')?.addEventListener('click', () => show(index - 1));
    $('[data-lx13-next]')?.addEventListener('click', () => show(index + 1));
    const gallery = $('[data-lx13-gallery]');
    if (gallery) {
      let sx = 0, sy = 0;
      gallery.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.2) show(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
      gallery.querySelectorAll('img[loading="lazy"]').forEach((img, i) => { if (i < 3) img.loading = 'eager'; });
    }

    /* variants */
    let variants = [];
    try { variants = JSON.parse($('[data-lx13-variants]')?.textContent || '[]'); } catch (e) {}
    const form = root.querySelector('#lx13-form');
    const idInput = $('[data-lx13-variant-input]');
    const optionInputs = $$('[data-lx13-option]');
    const addBtn = $('[data-lx13-add]');
    const addLabel = $('[data-lx13-add-label]');
    let current = variants.find((v) => String(v.id) === idInput?.value) || variants[0];
    // the shop's money format prints 1,949 — show prices the Swedish way
    if (current) $$('[data-lx13-price], [data-lx13-price-mirror]').forEach((el) => { el.textContent = money.format(current.price / 100); });

    const applyVariant = (v, moveGallery) => {
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      const price = money.format(v.price / 100);
      $$('[data-lx13-price], [data-lx13-price-mirror]').forEach((el) => { el.textContent = price; });
      $$('[data-lx13-option-label]').forEach((el, i) => { el.textContent = v.options[i] ?? el.textContent; });
      const sv = $('[data-lx13-sticky-variant]');
      if (sv) sv.textContent = v.title;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Lägg i varukorgen' : 'Inte tillgänglig';
      if (moveGallery && v.media) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(v.media));
        if (i > -1) show(i);
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
    };
    const selected = () => {
      const groups = {};
      optionInputs.forEach((i) => { if (i.checked) groups[i.name] = i.value; });
      return Object.keys(groups).sort().map((k) => groups[k]);
    };
    optionInputs.forEach((input) => input.addEventListener('change', () => {
      const values = selected();
      applyVariant(variants.find((v) => values.every((val, i) => v.options[i] === val)), true);
    }));
    const preset = new URLSearchParams(location.search).get('variant');
    if (preset) {
      const v = variants.find((x) => String(x.id) === preset);
      if (v) {
        optionInputs.forEach((i) => { i.checked = v.options.includes(i.value); });
        applyVariant(v, true);
      }
    }

    /* delivery estimate (5–10 days) */
    const eta = $('[data-lx13-eta]');
    if (eta) {
      const d = (n) => { const x = new Date(); x.setDate(x.getDate() + n); return x; };
      const day = new Intl.DateTimeFormat('sv-SE', { day: 'numeric' });
      const full = new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' });
      const a = d(5), b = d(10);
      const range = a.getMonth() === b.getMonth() ? `${day.format(a)}–${full.format(b)}` : `${full.format(a)} – ${full.format(b)}`;
      eta.textContent = `${range.replace(/\./g, '')}`;
    }

    /* add to bag */
    const panel = $('[data-lx13-added]');
    const errorEl = $('[data-lx13-error]');
    const openPanel = () => {
      if (!panel) return;
      const img = panel.querySelector('[data-lx13-added-img]');
      if (img && current?.image) img.src = current.image;
      const vt = panel.querySelector('[data-lx13-added-variant]');
      if (vt) vt.textContent = current?.title || '';
      panel.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('is-open')));
      panel.querySelector('.lx13-btn')?.focus({ preventScroll: true });
    };
    const closePanel = () => {
      if (!panel || panel.hidden) return;
      panel.classList.remove('is-open');
      setTimeout(() => { panel.hidden = true; }, 600);
    };
    panel?.addEventListener('click', (e) => { if (e.target === panel || e.target.closest('[data-lx13-added-close]')) closePanel(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });

    form?.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      addBtn.disabled = true;
      if (errorEl) errorEl.hidden = true;
      addLabel.textContent = 'Lägger till…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        });
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Något gick fel. Försök igen.');
        const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => null);
        if (cart) {
          document.querySelectorAll('cart-icon').forEach((el) => el.renderCartBubble?.(cart.item_count));
          try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() })); } catch (err) {}
        }
        addBtn.classList.add('is-done');
        addLabel.textContent = 'Tillagd ✓';
        openPanel();
        setTimeout(() => { addBtn.classList.remove('is-done'); addLabel.textContent = 'Lägg i varukorgen'; addBtn.disabled = false; }, 2200);
      } catch (err) {
        addBtn.disabled = false;
        addLabel.textContent = 'Lägg i varukorgen';
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      }
    });

    /* sticky purchase bar */
    const sticky = $('[data-lx13-sticky]');
    const stickyBtn = $('[data-lx13-sticky-add]');
    const hero = $('.lx13-film') || $('.lx13-hero');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      let addVisible = false, heroVisible = true, footerVisible = false;
      const update = () => {
        const on = !addVisible && !heroVisible && !footerVisible;
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', String(!on));
        stickyBtn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(([e]) => { addVisible = e.isIntersecting; update(); }).observe(addBtn);
      if (hero) new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; update(); }).observe(hero);
      const end = $('.lx13-closing') || document.querySelector('footer');
      if (end) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); }).observe(end);
      stickyBtn.addEventListener('click', () => form?.requestSubmit ? form.requestSubmit() : form?.submit());
    }

    /* silver / gold comparison */
    const compare = $('[data-lx13-compare]');
    const range = $('[data-lx13-compare-range]');
    if (compare && range) {
      const set = () => compare.style.setProperty('--compare', `${range.value}%`);
      range.addEventListener('input', set, { passive: true });
      set();
    }
    $$('[data-lx13-choose]').forEach((btn) => btn.addEventListener('click', () => {
      const input = optionInputs.find((i) => i.value === btn.dataset.lx13Choose);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      $('#kop')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }));
  };

  const start = () => document.querySelectorAll('[data-lx13]').forEach(boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (e) => boot(e.target.querySelector('[data-lx13]')));
})();

/* ---------- the campaign film: cuts between the photographs ---------- */
(() => {
  const start = () => {
    const film = document.querySelector('[data-lx13-film]');
    if (!film) return;
    // the film fills the screen below the header
    const fit = () => film.style.setProperty('--lx13-film-top', Math.max(0, film.getBoundingClientRect().top + (document.querySelector('.page-wrapper')?.scrollTop || scrollY)) + 'px');
    fit();
    addEventListener('resize', fit, { passive: true });

    const reel = film.querySelector('[data-lx13-reel]');
    if (!reel) return;
    const cap = film.querySelector('[data-lx13-cap]');
    const bars = film.querySelector('[data-lx13-bars]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const phone = matchMedia('(max-width: 749px)');
    const SHOT = 4600;
    film.style.setProperty('--lx13-shot', SHOT + 'ms');

    let shots = [], i = -1, timer = 0, visible = true;
    const show = n => {
      const prev = shots[i];
      i = (n + shots.length) % shots.length;
      const cur = shots[i];
      shots.forEach(s => { if (s !== cur && s !== prev) s.classList.remove('is-on', 'is-prev', 'is-push', 'is-pull'); });
      if (prev && prev !== cur) { prev.classList.remove('is-on'); prev.classList.add('is-prev'); setTimeout(() => prev.classList.remove('is-prev', 'is-push', 'is-pull'), 1600); }
      cur.classList.remove('is-prev', 'is-push', 'is-pull');
      void cur.offsetWidth; // restart the camera move
      cur.classList.add('is-on', i % 2 ? 'is-pull' : 'is-push');
      if (cap) {
        cap.classList.remove('is-on');
        setTimeout(() => { cap.innerHTML = `<b>${String(i + 1).padStart(2, '0')} / ${String(shots.length).padStart(2, '0')}</b>${cur.dataset.cap}`; cap.classList.add('is-on'); }, 350);
      }
      if (bars) [...bars.children].forEach((b, k) => {
        b.classList.toggle('is-done', k < i);
        b.classList.remove('is-on'); void b.offsetWidth;
        if (k === i) b.classList.add('is-on');
      });
      clearTimeout(timer);
      if (!reduce && visible) timer = setTimeout(() => show(i + 1), SHOT);
    };
    const build = () => {
      const want = phone.matches ? 'mob' : 'desk';
      shots.forEach(s => s.classList.remove('is-on', 'is-prev', 'is-push', 'is-pull'));
      shots = [...reel.children].filter(s => s.dataset.on === want);
      if (bars) {
        bars.innerHTML = '';
        shots.forEach((s, k) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `Bild ${k + 1}: ${s.dataset.cap}`);
          b.innerHTML = '<i></i>';
          b.addEventListener('click', () => show(k));
          bars.appendChild(b);
        });
      }
      i = -1;
      show(0);
    };
    build();
    phone.addEventListener?.('change', build);

    // rest while the film is out of view or the tab is hidden
    const pause = on => {
      visible = !on;
      film.classList.toggle('is-paused', on);
      clearTimeout(timer);
      if (!on && !reduce) timer = setTimeout(() => show(i + 1), SHOT);
    };
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => pause(!e.isIntersecting), { threshold: 0.15 }).observe(film);
    document.addEventListener('visibilitychange', () => pause(document.hidden));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
